import { ShoppingCart, X } from 'lucide-react';
import { useShallow } from 'zustand/react/shallow';
import { useLocation } from '@tanstack/react-router';
import cartStore from '@/stores/cart.store.ts';

export default function CartButton() {
	const location = useLocation();

	const { isCartOpen, toggle, counter, hasItems } = cartStore(
		useShallow((state) => ({
			isCartOpen: state.isCartOpen,
			toggle: state.toggleCartState,
			hasItems: !!state.items.length,
			counter: state?.items.length,
		})),
	);

	const isCartHidden = location.pathname.startsWith('/order-service') || !hasItems;

	return (
		!isCartHidden && (
			<button
				className="header-button w-[44px] h-[44px] shrink-0 border ml-4 relative border-neutral-300 p-2 rounded-lg text-neutral-600 cursor-pointer active:scale-97 hover:border-orange-600 transition-all"
				onClick={toggle}
			>
				{isCartOpen ? <X /> : <ShoppingCart />}

				<div className="absolute w-5 h-5 rounded-full shrink-0 bg-[var(--primary)] top-[-8px] left-[-8px] max-sm:top-[-6px] max-sm:left-[-6px] text-white text-xs font-bold flex items-center justify-center">
					{counter}
				</div>
			</button>
		)
	);
}
